// src/pages/ResetPasswordConfirmPage.js
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { confirmResetPassword } from '../api/auth';
import {
  TextField,
  Button,
  Container,
  Typography,
  Alert,
  Box
} from '@mui/material';

export default function ResetPasswordConfirmPage() {
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    setSuccessMsg('');

    try {
      await confirmResetPassword(uid, token, newPassword);
      setSuccessMsg('Your password has been reset successfully.');

      // Redirect to login after a short delay
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      console.error('Password reset confirmation failed:', err);
      // You can refine this based on backend error shape
      setError('Unable to reset password. The link may be invalid or expired.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Enter New Password
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {successMsg && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {successMsg}
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          type="password"
          label="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          margin="normal"
          required
        />
        <Button
          type="submit"
          variant="contained"
          disabled={submitting || !newPassword}
          sx={{ mt: 2 }}
        >
          {submitting ? 'Resetting...' : 'Reset Password'}
        </Button>
      </Box>
    </Container>
  );
}
